import Image from "next/image";
import React, { useState, useRef, useEffect } from 'react';
import gaTracker from "@/ga";
import { Icon } from "@iconify/react";
import useLogin from "@/hooks/useLogin";
import Modal from '@/components-mobile/Modal';
import LoginModal from "@/components/LoginModal";
import FreeSamplePopup from '@/components-mobile/FreeSamplePopup';
import { APICapInvitation, APIRefreshCapStatus } from '@/api';
import styles from './index.module.scss';
import useLanguage from "@/hooks/useLanguage";

const ProductCard = ({ sourceData, typePage, obtain, selectedProducts, toggleSelection, collectChange, viewChange, addChange, goDetailPage, switchObtain }) => {
  // console.log('~productCard', obtain, sourceData);
  const { needLogin } = useLogin();
  const { t } = useLanguage();
  const [getFreeSample, setGetFreeSample] = useState(false);
  const [collected, setCollected] = useState(sourceData.collect);
  const [openTipSample, setOpenTipSample] = useState(false);
  const [code, setcode] = useState();
  const [noEligible, setNoEligible] = useState(false);
  const [eligibleModal, setEligibleModal] = useState(false);  // 签约成功
  const [eligible7dayModal, setEligible7dayModal] = useState(false);
  const [showConnectTips, setShowConnectTips] = useState(false);  // 登录提示
  // const [obtainRef, setObtainRef] = useState(obtain);
  const img = typePage === 'home' || typePage === 'hotSale' || typePage === 'detail' || typePage === 'collection' || typePage === 'commission'
    ? sourceData.alyImage ? sourceData.alyImage : sourceData.image
    // : typePage === 'commission'
    //   ? sourceData.productImage
    : sourceData?.main_images?.[0]?.url;
  const finishRate = typePage === 'showcases' ?
    sourceData?.product?.finishRate ? sourceData?.product?.finishRate + '%' : "-"
    : sourceData.finishRate ? sourceData?.finishRate + '%' : "-";
  const capRate = typePage === 'showcases' ?
    sourceData?.product?.capRate ? sourceData?.product?.capRate + '%' : "-"
    : sourceData?.capRate ? `${sourceData?.capRate}%` : "-";
  const isSelectedProducts = selectedProducts?.includes(sourceData?.productId);
  const getPrice = typePage !== 'showcases'
    ? sourceData?.showPrice
    : sourceData?.price?.platform_discount_price?.minimum_amount + '-' + sourceData?.price?.platform_discount_price?.maximum_amount;
  const toggleCollect = (e) => {
    e.stopPropagation();
    if (!needLogin) {
      setCollected(!collected);
    }
    collectChange(e, sourceData, collected);
  };
  const tipList = [
    {
      text: t('product_h5.top_selling'),
      color: '#FF6C4F',
      bg: 'rgba(248, 240, 237, 0.94)',
      isShow: sourceData?.productTag2 === 1 ? true : false
    },
    {
      text: t('product_h5.trending'),
      color: '#E04DB1',
      bg: 'rgba(248, 237, 247, 0.94)',
      isShow: sourceData?.productTag3 === 1 ? true : false
    },
    {
      text: t('product_h5.free_sample'),
      color: '#1DA963',
      bg: 'rgba(232, 241, 239, 0.94)',
      isShow: sourceData?.productTag1 === 1 ? true : false
    }
  ];
  const tipGoSample = () => {
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    if (needLogin) {
      setShowConnectTips(true);
      return;
    }
    if (!obtain) {
      setOpenTipSample(true);
      if (typePage === 'home') {
        gaTracker.trackEvent("home_cap_comm");
      } else if (typePage === 'detail') {
        gaTracker.trackEvent("details_rec_cap_comm");
      } else if (typePage === 'collection') {
        gaTracker.trackEvent("collection_cap_comm");
      } else if (typePage === 'commission') {
        gaTracker.trackEvent("commincrease_cap_comm");
      } else if (typePage === 'hotSale') {
        gaTracker.trackEvent("pop_cap_comm");
      }
    }
  };

  const getCapInvite = () => {
    APICapInvitation()
      .then((resp) => {
        if (resp.code === '1' && resp?.data?.result?.isSucess) {
          setEligibleModal(true);
        } else if (!resp?.data?.result?.isSucess) {
          setEligible7dayModal(true);
        }
        setcode(resp?.data?.result?.code);
      }).catch((e) => { console.log(e); });
  };
  const reEligible = () => {
    // gaTracker.trackEvent("profile_already");
    APIRefreshCapStatus()
      .then((resp) => {
        if (resp?.data?.result) {
          // setObtainRef(true);
          switchObtain();
        } else {
          setNoEligible(true);
        }
      });
  };
  return (
    <div id='step2' className={styles.productCard} >
      <div className={styles.imageBox} onClick={() => { goDetailPage(sourceData); }}>
        <img className={`${styles.image} ${typePage === 'commission' && styles.imageCom}`} src={img} />
        <div className={styles.tipBox}>
          {(typePage === 'home' || typePage === 'hotSale') && tipList.map((item, index) => (<div key={index}>
            {item.isShow && <div className={styles.tip} style={{ background: item.bg, color: item.color }}>{item.text}</div>}
          </div>)
          )}
          {(typePage === 'collection' || typePage === 'commission')
            && <img src={!isSelectedProducts ? '/images/product/unSelect.png' : '/images/product/selected.png'}
              onClick={(e) => { toggleSelection(e, sourceData); }}
              className={!isSelectedProducts ? styles.unSelect : styles.selectIcon} />
            // <Icon onClick={(e) => { toggleSelection(e, sourceData); }}
            //   icon='solar:check-circle-line-duotone'
            //   className={!isSelectedProducts ? styles.unSelect : styles.selectIcon} />
          }
        </div>
        {(typePage !== 'showcases' && typePage !== 'commission') && <div className={styles.collectBox} onClick={(e) => { toggleCollect(e, sourceData); }} >
          <Icon icon='solar:star-bold-duotone'
            className={`${styles.collect} ${collected ? styles.collectActive : ''}`}
          />
        </div>}
        {(typePage === 'showcases' || typePage === 'commission') && <div className={styles.statusBox}>
          {typePage === 'showcases' && <span className={`${styles.status} ${sourceData?.status?.inventory_status !== 'IN_STOCK' ? styles.statusBad : ''}`}>{sourceData?.status.inventory_status}</span>}
          {typePage === 'commission' && <span className={`${styles.status} ${sourceData?.inventoryStatus !== 'IN_STOCK' ? styles.statusBad : ''}`}>{sourceData?.inventoryStatus}</span>}

        </div>}
        <div className={styles.mainInfo}>
          <div className={styles.title}>{sourceData?.title}</div>
          <div className={styles.price}>{(typePage === 'showcases' || typePage === 'commission') && t('product_h5.price')}{getPrice ?? '-'}</div>
        </div>
      </div>
      {typePage !== 'commission' && <div className={styles.contentEarn}>
        <div className={styles.earnTitle}>{typePage === 'showcases' ? `${sourceData?.commission?.rate / 100}%` ?? "-" : `${obtain ? sourceData?.showCapEarnPer ?? "-" : sourceData?.showEarnPer ?? "-"}`}</div>
        <div className={styles.earnText}>{typePage === 'showcases' ? t('product_h5.current_commission') : t('product_h5.earn_per_sale')}</div>
      </div>}
      {typePage === 'commission' && <div className={styles.contentEarn}>
        <div className={styles.commisText}>{t('product_h5.current_commission')}：<span className={styles.commisNum}>{sourceData?.currentRate}%</span></div>
        <div className={styles.commisText}>{t('product_h5.anystarr_commission')}:</div>
      </div>}
      {((typePage === 'showcases' && sourceData?.isPlatformProduct) || typePage !== 'showcases') &&
        <div className={styles.earns}>
          <div className={styles.earnsWarp}>
            <div className={styles.earnsMin}>
              <span className={`${styles.earnNum} ${obtain && styles.earnNumDiff}`}>{finishRate}</span>
              {!obtain && <Icon icon='dashicons:yes-alt' className={styles.earnsMinIcon} />}
            </div>
            <div className={styles.earnsTip}>{t('product_h5.earnings')}</div>
          </div>
          <Icon icon='quill:arrow-right' className={styles.earnGo} />
          <div className={styles.earnsWarp} onClick={tipGoSample}>
            <div className={`${styles.earnsMax} ${obtain && styles.earnsMaxDiff}`}>
              <span className={styles.earnNum}>{capRate}</span>
              {obtain
                ? <Icon icon='dashicons:yes-alt' className={styles.earnsMinIcon} />
                : <Icon icon='mdi:lock' className={styles.earnsMaxIcon} />}
            </div>
            <div className={styles.earnsTip}>{t('product_h5.max_earnings')}</div>
          </div>
        </div>}
      {typePage !== 'showcases' &&
        <div className={styles.button}>
          <div className={styles.sample} onClick={(e) => {
            e.stopPropagation();
            if (typePage === 'home') {
              gaTracker.trackEvent("home_sample");
            } else if (typePage === 'detail') {
              gaTracker.trackEvent("details_rec_sample");
            } else if (typePage === 'collection') {
              gaTracker.trackEvent("collection_sample");
            } else if (typePage === 'commission') {
              gaTracker.trackEvent("commincrease_sample");
            } else if (typePage === 'hotSale') {
              gaTracker.trackEvent("pop_sample");
            }
            let user = localStorage.getItem("user");
            user = JSON.parse(user);
            if (needLogin) {
              setShowConnectTips(true);
              return;
            }
            setGetFreeSample(true);
          }}>
            <Image width={16} height={16} className={"w-4 h-4 mr-1"} src={"/images/free-sample.svg"} alt={""}></Image>{t('product_h5.sample')}</div>
          <div className={styles.add} onClick={(e) => { addChange(e, sourceData); }}>
            <Image width={16} height={16} className={"w-4 h-4 mr-1"} src={"/images/add-showcase.svg"} alt={""} />{t('product_h5.add')}</div>
        </div>
      }
      {typePage === 'showcases' &&
        <div className={`${styles.view} ${sourceData?.isPlatformProduct ? styles.viewDiff : ''}`} onClick={(e) => { viewChange(e, sourceData); }}>
          <img className={`${sourceData?.isPlatformProduct ? styles.viewIcon : styles.similarIcon}`} src={`${sourceData?.isPlatformProduct ? '/images/profile/link-icon.svg' : '/images/profile/similar-icon.svg'}`} />
          <div className={styles.text}>{sourceData?.isPlatformProduct ? t('product_h5.view') : t('product_h5.similar')}</div>
        </div>
      }
      <FreeSamplePopup
        isVisible={getFreeSample}
        sourceData={sourceData}
        obtainRef={obtain}
        closePopup={() => setGetFreeSample(false)}
        getCapInvite={() => {
          gaTracker.trackEvent("sam_obtain_h5");
          getCapInvite();
          setGetFreeSample(false);
        }}
        reEligible={() => {
          reEligible();
          setGetFreeSample(false);
        }}
        title={t('details_mobile.get_sample')}
        addChange={(e) => addChange(e, sourceData)}
      />
      {
        openTipSample && <Modal cancel={() => setOpenTipSample(false)}
          type='sample'
          getCapInvite={() => {

            getCapInvite();
            setOpenTipSample(false);
          }}
          reEligible={() => {
            reEligible();
            setOpenTipSample(false);
          }} />
      }
      {
        eligibleModal && <Modal type={'success'} cancel={() => { setEligibleModal(false); }}>
          <div>{t('product_h5.modal.success_message', {
            uango: <span className={styles.tipTextDiff}>Uango</span>,
            accept: <span className={styles.tipTextDiff}>{t('product_h5.modal.accept_request')}</span>
          })}</div>
        </Modal>
      }
      {
        eligible7dayModal && <Modal
          cancel={() => setEligible7dayModal(false)}
        >
          {code === 16004004 && <div>{t('product_h5.modal.error_not_creator')}</div>}
          {code === 16004005 && <div>{t('product_h5.modal.error_already_joined1')}
            <span className={styles.tipTextDiff}> {t('unlock_commission.already')}</span>
            {t('product_h5.modal.error_already_joined2')}
            <span className={styles.tipTextDiff}>  {t('product_h5.modal.cancel_contract')}</span>
            {t('product_h5.modal.error_already_joined3')}
          </div>}
          {code === 16004006 && <div>{t('product_h5.modal.error_link_sent1')}
            <span className={styles.tipTextDiff}> {t('product_h5.modal.error_link_sent2')}</span>
            {t('product_h5.modal.error_link_sent3')}
            <span className={styles.tipTextDiff}> {t('product_h5.modal.error_link_sent4')}</span>
          </div>}
          {code === 16004014 && <div>{t('product_h5.modal.error_has_shop')}</div>}
          {code === 16007119 && <div>{t('product_h5.modal.error_link_sent5')}<span className={styles.tipTextDiff}>{t('product_h5.modal.error_link_sent6')}</span></div>}
          {code !== 16004004
            && code !== 16004005
            && code !== 16004006
            && code !== 16004014
            && code !== 16007119
            && code !== 0
            && <div>{t('product_h5.modal.error_unknown1')}<span className={styles.tipTextDiff}>{t('product_h5.modal.error_unknown2')}</span></div>}
        </Modal>
      }
      {
        noEligible && <Modal cancel={() => setNoEligible(false)}>
          <div>{t('product_h5.modal.join_program1')} <span className={styles.tipTextDiff}>{t('product_h5.modal.join_program2')}</span>
            {t('product_h5.modal.join_program3')}<span className={`underline ${styles.tipTextDiff}`} onClick={() => { setNoEligible(false); getCapInvite(); }}>{t('product_h5.modal.obtain_eligibility')}</span>
            {t('product_h5.modal.join_program4')}</div>
        </Modal>
      }
      <LoginModal open={showConnectTips} mobile={true} onCancel={() => setShowConnectTips(false)}></LoginModal>
    </div >
  );
};
export default ProductCard;
